import React from "react";
import contentImage from "../../../../assets/images/contentImage.png";

const index = () => {
  return (
    <div className="min-w-[277px]  relative rounded-[12px] hidden lg:block">
      <img
        className="w-[100%] h-[100%] min-h-[344px] max-h-[500px] bg-cover rounded-[12px]"
        src={contentImage}
        alt="contentImage"
      />
      <div className="absolute bottom-[5%]  flex items-center">
        <span className="px-[8px]">
          <svg
            width="56"
            height="44"
            viewBox="0 0 56 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 14V30M18 16L6 28M20 22H4M18 28L6 16"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M28 23.664V18.12H29.944V23.532C29.944 24.648 30.556 25.26 31.648 25.26C32.752 25.26 33.376 24.624 33.376 23.532V18.12H35.32V23.664C35.32 25.776 33.88 27.144 31.648 27.144C29.428 27.144 28 25.788 28 23.664Z"
              fill="white"
            />
            <path d="M38.7269 27H36.8789V17.952H38.7269V27Z" fill="white" />
            <path
              d="M44.0972 21H45.9452V27H44.2052L44.0853 26.328C43.7133 26.82 42.9693 27.156 42.2493 27.156C40.8813 27.156 40.0413 26.244 40.0413 24.768V21H41.8892V24.096C41.8892 25.08 42.2252 25.512 42.9812 25.512C43.7732 25.512 44.0972 25.104 44.0972 24.12V21Z"
              fill="white"
            />
            <path
              d="M47.032 23.892C47.032 22.068 48.22 20.796 49.912 20.796C50.728 20.796 51.376 21.108 51.7 21.6L51.796 21H53.536V26.616C53.536 28.764 52.3 30.06 50.248 30.06C48.412 30.06 47.176 29.016 47.008 27.312H48.88C48.916 27.984 49.42 28.38 50.236 28.38C51.124 28.38 51.688 27.852 51.688 27V26.22C51.328 26.652 50.656 26.928 49.876 26.928C48.196 26.928 47.032 25.692 47.032 23.892ZM48.892 23.844C48.892 24.708 49.468 25.32 50.284 25.32C51.124 25.32 51.688 24.732 51.688 23.844C51.688 22.968 51.124 22.404 50.272 22.404C49.456 22.404 48.892 22.992 48.892 23.844Z"
              fill="white"
            />
          </svg>
        </span>
        <span className="text-white px-[8px]">|</span>
        <span className="text-[#34BD5A] text-[14px] px-[8px]">
          Akıllı Test
        </span>
      </div>
    </div>
  );
};

export default index;
